import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import ProgressTab from './ProgressTab';
import EventLogTab from './EventLogTab';
import MeasurementsTab from './MeasurementsTab';

import type { RunExecutionStatus, ItemExecutionStatus } from '../../types/mqtt';
import type {
  ExecutionEvent,
  Measurement
} from '../../hooks/useExecutionStatus';

type Props = {
  runStatus: RunExecutionStatus | null;
  itemStatus: ItemExecutionStatus | null;
  events: ExecutionEvent[];
  measurements: Measurement[];
  scriptId?: string;
  runId?: string;
  measurementsSlot?: React.ReactNode;
};

const ExecutionPanel: React.FC<Props> = ({
  runStatus,
  itemStatus,
  events,
  measurements,
  scriptId,
  runId,
  measurementsSlot
}) => {
  const [tab, setTab] = useState(measurementsSlot ? 2 : 0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        sx={{
          minHeight: 36,
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': { minHeight: 36, py: 0, textTransform: 'none' }
        }}
      >
        <Tab label="Progress" />
        <Tab label={`Event Log (${events.length})`} />
        <Tab label={`Measurements (${measurements.length})`} />
      </Tabs>
      <Box sx={{ flex: 1 }}>
        {tab === 0 && (
          <ProgressTab runStatus={runStatus} itemStatus={itemStatus} />
        )}
        {tab === 1 && <EventLogTab events={events} />}
        {tab === 2 &&
          (measurementsSlot ?? (
            <MeasurementsTab
              measurements={measurements}
              scriptId={scriptId}
              runId={runId}
            />
          ))}
      </Box>
    </Box>
  );
};

export default ExecutionPanel;
